import clsx from 'clsx';
import { HTMLAttributes } from 'react';

const HEADER_HEIGHT = 'h-[48px] flex-shrink-0';
const TOP_NAV_HEIGHT = 'flex-shrink-0';

export function PageLayoutRoot({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx('flex w-full flex-row', className)}
      style={{ height: 'calc(100% - 56px)' }}
      {...rest}
    />
  );
}
export function PageLayoutSidebar({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('flex flex-col border-r border-default', className)} {...rest} />;
}

export function PageLayoutSidebarLogoContainer({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('flex items-center p-6', HEADER_HEIGHT, className)} {...rest} />;
}

export function PageLayoutMain({
  className,
  computedMatch,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { computedMatch?: any }) {
  return <div className={clsx('flex flex-col flex-grow min-w-0', className)} {...rest} />;
}

export function PageLayoutHeader({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        'flex flex-row w-full items-start justify-between px-6',
        TOP_NAV_HEIGHT,
        className,
      )}
      {...rest}
    />
  );
}

export function PageLayoutMainContent({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      id="main-content"
      className={clsx(
        'flex flex-grow flex-row overflow-x-hidden min-h-0 overflow-y-auto',
        className,
      )}
      {...rest}
    />
  );
}
